import { App } from '@tribeplatform/gql-client/types'
import { HtmlContent } from '@tribeplatform/react-sdk/components'
import { Card } from '@tribeplatform/react-ui-kit/Card'

export const AppAbout = ({ app }: { app: App }) => {
  if (app && !app?.about)
    return (
      <Card className="h-32">
        <div className="h-32 flex flex-col justify-center">
          <h3 className="text-center">This app has no description</h3>
        </div>
      </Card>
    )
  return (
    <Card>
      <Card.Content>
        {app?.about && <HtmlContent value={app?.about} />}
      </Card.Content>
    </Card>
  )
}
